var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('imgHeader',{attrs:{"imgUrl":"/img/3公司动态-banner.jpg"}}),_c('NewsCom',{attrs:{"title":_vm.$t('public.companyNews')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }